import React from 'react';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { useSnackbar } from 'notistack';
import TokenService from '../services/TokenService';
import AvailableOrders from './Pickups/AvailableOrders';
import OpenOrders from './Pickups/OpenOrders';
import CompletedOrders from './Pickups/CompletedOrders';
import Badge from '@mui/material/Badge'; 
import AddIcon from '@mui/icons-material/Add';
import TouchRipple from '@mui/material/ButtonBase/TouchRipple';
import { Button } from "@mui/material";
import TrainingItemsIndicator from './Training/TrainingItemsIndicator.jsx';
import StarTwoToneIcon from '@mui/icons-material/StarTwoTone';
import SchoolIcon from '@mui/icons-material/School';
import { Link } from 'react-router-dom';
import { Navigate } from "react-router-dom";
import FingerprintJS from 'fingerprintjs2';
import * as UAParser from 'ua-parser-js'


import './Pickups/Pickups.css'

function Pickups() {
    var Fingerprint2 = require("fingerprintjs2")

    const [loggedInUser, setLoggedInUser] = React.useState(null);
    const [userLevel, setUserLevel] = React.useState(null);
    const [isFetching, setIsFetching] = React.useState(true);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [selectedTab, setSelectedTab] = React.useState('1');
    const [redirectTo, setRedirectTo] = React.useState(null);
    const myOrdersTab = React.useRef(null);
    const availableOrdersTab = React.useRef(null);
    const completedOrdersTab = React.useRef(null);

    const handleTabChange = (event, newValue) => {
        setSelectedTab(newValue);
    };

    React.useEffect(() => {
        //#/Admin
        if (window.location.href.toLowerCase().indexOf('/#admin') > -1) {
            let queryParams = new URLSearchParams(window.location.href.substr(window.location.href.indexOf('?')));
            let orderParm = queryParams.get("Order");
            if (orderParm != null) {
                setRedirectTo('/Admin?Order=' + orderParm);
            }
            else {
                setRedirectTo('/Admin');
            }
            
        }
        else {
            loadAccount(); // only called once
        }
    }, []);

    function loadAccount() {
        //if (sessionStorage.getItem('LoggedInUser') != null) {
        //    setLoggedInUser(JSON.parse(sessionStorage.getItem('LoggedInUser')));
        //    setIsFetching(false);
        //}
        //else
        {
            TokenService.post('', 'Returner_MyAccount')
                .then((response) => {
                    response = response[Object.keys(response)[0]];
                    if (response.Result == "SUCCESS") {
                        let jsonData = JSON.parse(response.JsonData);
                        if (typeof jsonData === 'string') {
                            jsonData = JSON.parse(jsonData);
                        }
                        let returnerData = jsonData.ReturnerData;
                        if (typeof returnerData === 'string') {
                            returnerData = JSON.parse(returnerData);
                        }
                        setLoggedInUser(returnerData);
                        sessionStorage.setItem('LoggedInUser', JSON.stringify(returnerData));
                        setIsFetching(false);

                        _getFingerprint().then((result) => {
                            if (result != null)
                            {
                                var postData = {
                                    fingerprint: result
                                }
                                TokenService.post(postData, 'Returner_Associate');
                            }
                        })
                    }
                })
                .catch((response) => {
                    enqueueSnackbar('Oops, something went wrong', {
                        variant: 'error',
                    });
                });
        }
    }

    function _getFingerprint() {
        return new Promise((resolve, reject) => {
            async function getHash() {
                const options = {
                    excludes: {
                        plugins: true,
                        localStorage: true,
                        adBlock: true,
                        screenResolution: true,
                        availableScreenResolution: true,
                        enumerateDevices: true,
                        pixelRatio: true,
                        doNotTrack: true
                    },
                    preprocessor: (key, value) => {
                        if (key === 'userAgent') {
                            const parser = new UAParser(value)
                            // return customized user agent (without browser version)
                            return `${parser.getOS().name} :: ${parser.getBrowser().name} :: ${parser.getEngine().name}`
                        }
                        return value
                    }
                }

                try {
                    const components = await Fingerprint2.getPromise(options)
                    const values = components.map(component => component.value)
                    console.log('fingerprint hash components', components)

                    return String(Fingerprint2.x64hash128(values.join(''), 31))
                } catch (e) {
                    reject(e)
                }
            }

            if (window.requestIdleCallback) {
                console.log('requestIdleCallback')
                requestIdleCallback(async () => resolve(await getHash()))
            } else {
                console.log('setTimeout')
                setTimeout(async () => resolve(await getHash()), 500)
            }
        })
    }

    function handleOrderMoved(movedFrom, movedTo) {
        //console.log('handleOrderMoved: ' + movedFrom + ' to ' + movedTo);
        if (movedTo == 'OpenOrders') {
            myOrdersTab.current.start();
            window.setTimeout(function () {
                myOrdersTab.current.stop();
            }, 500);


            window.setTimeout(function () {
                myOrdersTab.current.start();
                window.setTimeout(function () {
                    myOrdersTab.current.stop();
                }, 500);
            }, 200);
        }
        else if (movedTo == 'CompletedOrders') {
            completedOrdersTab.current.start();
            window.setTimeout(function () {
                completedOrdersTab.current.stop();
            }, 500);


            window.setTimeout(function () {
                completedOrdersTab.current.start();
                window.setTimeout(function () {
                    completedOrdersTab.current.stop();
                }, 500);
            }, 200);
        }
    }

    function handleUserLevelUpdated(updatedLevelInfo) {
        if (userLevel != null) {
            //if (userLevel.TrainingChecklist.RemainingItemCount > 0 &&
            //    updatedLevelInfo.TrainingChecklist.RemainingItemCount == 0) {
            //    alert('all training completed');
            //}
        }
  
        setUserLevel(updatedLevelInfo);
    }

    function buildWelcome() {
        return (<div>
            <div style={{ backgroundColor: 'var(--sipzee-gray)', color: 'var(--sipzee-green)', fontSize: '22pt', fontWeight: 'bold' }}>Welcome to Sipzee!</div>
            <div style={{marginTop:'15px'} }>
                <SchoolIcon sx={{ color: 'var(--sipzee-yellow' }} style={{ marginRight: '10px' }} /> We want to get you off to a great start! 
            </div>
            <div style={{ marginTop: '15px' }}>
                Before you can start viewing orders, you have to complete a short Account Setup Checklist.
            </div>
            {userLevel.TrainingChecklist.IsTrainingCompleted ? 
                <div style={{ marginTop: '15px' }}>
                    These can be found in <Link to='/MyAccount'>My Account</Link>.
                </div>
                :
                <div style={{ marginTop: '15px' }}>
                    We recommend starting with the <Link to='/Training'>Training Module</Link>.
                </div>    
            }
            
        </div>)
    }

    if (redirectTo !== null) {
        return <Navigate to={redirectTo} />
    }

    return (
       
        
        <>
            {userLevel == null || userLevel == undefined || userLevel.TrainingChecklist == undefined ? null :
                <TrainingItemsIndicator ShowIndicator={true} TrainingChecklist={userLevel.TrainingChecklist} />
            }

            {userLevel != null && userLevel != undefined && userLevel.TrainingChecklist != undefined && userLevel.TrainingChecklist.RemainingItemCount > 0 ?
                buildWelcome()
                :
                <TabContext value={selectedTab} >
                    <TabList
                        className="tabHeader"
                        variant="fullWidth"
                        textColor="primary"
                        indicatorColor="secondary"
                        onChange={handleTabChange} aria-label="Service Areas Tabs">
                        <Tab style={{ fontWeight: 'bold' }}
                            label={<div className='RippleTab'>Available Orders<TouchRipple ref={availableOrdersTab} center={true} /></div>}
                            value="1" />

                        <Tab style={{ fontWeight: 'bold' }}
                            label={
                                <Badge badgeContent={userLevel == null ? 0 : userLevel.UnreadMessages}
                                    color="sipzeeRed"
                                    overlap="circular"

                                    sx={{ zIndex: 1051 }}
                                    anchorOrigin={{
                                        vertical: 'top',
                                        horizontal: 'right',
                                    }}
                                >
                                    <div className='RippleTab'>My Open Orders<TouchRipple ref={myOrdersTab} center={true} /></div>
                                </Badge>
                            }
                            value="2" />

                        <Tab style={{ fontWeight: 'bold' }}
                            label={<div className='RippleTab'>Completed Orders<TouchRipple ref={completedOrdersTab} center={true} /></div>}
                            value="3" />
                    </TabList>

                    <TabPanel value="1" style={{ padding: '10px' }}>
                        <AvailableOrders isFetching={isFetching} loggedInUser={loggedInUser} orderMoved={handleOrderMoved} userLevel={userLevel} userLevelUpdated={handleUserLevelUpdated} />
                    </TabPanel>
                    <TabPanel value="2" style={{ padding: '5px' }}>
                        <OpenOrders isFetching={isFetching} loggedInUser={loggedInUser} orderMoved={handleOrderMoved} userLevel={userLevel} userLevelUpdated={handleUserLevelUpdated} />
                    </TabPanel>
                    <TabPanel value="3" style={{ padding: '10px' }}>
                        <CompletedOrders isFetching={isFetching} loggedInUser={loggedInUser} userLevel={userLevel} userLevelUpdated={handleUserLevelUpdated} />
                    </TabPanel>
                </TabContext>
            }
        </>
    
  );
}

export default Pickups;